import formFieldComponents from "../Patient/ApplicationFormEditor/components/form/utils/formFieldComponents";
import { beUIFieldNamesMap } from "./constants";
import * as validationRules from "../Patient/ApplicationFormEditor/utils";

export const schemaTypes = {
  string: "string",
  number: "number",
  boolean: "boolean",
  object: "object",
  array: "array",
  null: "null"
};

const fieldTypes = Object.keys(formFieldComponents);

const ruleOptions = Object.keys(validationRules);

const baseFieldItemSchema = {
  type: {
    type: schemaTypes.string,
    enum: fieldTypes
  },
  required: {
    type: schemaTypes.boolean
  },
  BEName: {
    type: [schemaTypes.string, schemaTypes.null],
    enum: [...Object.keys(beUIFieldNamesMap), null]
  },
  fieldProps: {
    type: schemaTypes.object
  },
  formItemProps: {
    type: schemaTypes.object
  },
  dedicatedFieldProps: {
    type: schemaTypes.object
  },
  fullLine: {
    type: schemaTypes.boolean,
    disable_edit_json: true,
    readonly: true
  },
  rules: {
    type: "array",
    items: {
      oneOf: [
        {
          type: "string",
          enum: ruleOptions
        },
        {
          type: "object",
          properties: {
            max: { type: "number" },
            message: { type: "string" }
          },
          required: ["max", "message"],
          additionalProperties: false
        }
      ]
    }
  },
  conditions: {
    type: schemaTypes.object,
    properties: {
      disabled: {
        type: schemaTypes.object,
        properties: {
          logic: {
            type: schemaTypes.string,
            enum: ["AND", "OR", null]
          },
          rules: {
            type: schemaTypes.array,
            items: {
              type: schemaTypes.object,
              properties: {
                operator: {
                  type: schemaTypes.string,
                  enum: ["=", "!=", ">", "<", ">=", "<=", "contains"]
                },
                relatedFieldName: {
                  type: schemaTypes.string
                },
                value: {}
              },
              required: ["operator", "relatedFieldName", "value"]
            }
          }
        }
      }
    }
  },
  rulesParams: {
    type: schemaTypes.object,
    properties: {
      mustMatchAllowedValues: {
        type: schemaTypes.object,
        properties: {
          allowedValues: {
            type: schemaTypes.array,
            items: {
              type: schemaTypes.string
            }
          },
          message: {
            type: schemaTypes.string
          }
        },
        required: ["allowedValues", "message"]
      }
    }
  }
};

export const jsonEditorSchema = {
  type: schemaTypes.object,
  properties: {
    formSections: {
      type: schemaTypes.array,
      items: {
        type: schemaTypes.object,
        properties: {
          rows: {
            type: schemaTypes.array,
            items: {
              type: schemaTypes.object,
              properties: {
                fields: {
                  type: schemaTypes.array,
                  items: {
                    type: schemaTypes.object,
                    properties: {
                      ...baseFieldItemSchema,
                      fieldMultiplier: {
                        type: schemaTypes.object,
                        properties: {
                          initialView: {
                            type: schemaTypes.number
                          },
                          fieldIterationNames: {
                            type: schemaTypes.array,
                            items: {
                              type: schemaTypes.string
                            }
                          },
                          subFields: {
                            type: schemaTypes.object,
                            properties: {
                              rows: {
                                type: schemaTypes.array,
                                items: {
                                  type: schemaTypes.object,
                                  properties: {
                                    fields: {
                                      type: schemaTypes.array,
                                      items: {
                                        type: schemaTypes.object,
                                        properties: baseFieldItemSchema
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    },
                    required: ["type"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
